import React from 'react';
import Navbar from './global-components/navbar-v2';
import PageHeader from './global-components/page-header';
import InquiryForm from './section-components/inquiry-form';
import Footer from './global-components/footer-v2';

const InquiryPage = () => {
    return (
        <div>
            <PageHeader headertitle="Inquiry" />
            <InquiryForm />
        </div>
    );
};

export default InquiryPage;
